import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { updateLimitType } from '../api/limitTypes.api';
import type { UpdateLimitTypePayload } from '../types/limitType.types';

interface UpdateLimitTypeArgs {
  id: number;
  payload: UpdateLimitTypePayload;
}

export function useUpdateLimitType(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: ({ id, payload }: UpdateLimitTypeArgs) => updateLimitType(id, payload),
    onSuccess: () => {
      void refreshRelatedData('limitType');
      toast.success('Limit updated successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to update limit');
    },
  });
}
